import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import Social from '../global/Social'
import Streaming from '../global/Streaming'

const Footer = props => {
  return (
    <footer className="mt-10 w-full border-t border-zinc-700 my-1 bg-zinc-900/60 p-4 py-10">
      <div className="container mx-auto flex-wrap lg:flex lg:flex-row">
        <div className="basis-3/4 order-1">
          <h3 className="font-bold text-xl text-white uppercase text-center lg:text-left mb-5">
            À propos de N47
          </h3>
          <div className="flex flex-wrap md:flex-nowrap md:flex-nowwrap flex-row items-stretch">
            <div className="basis-full md:basis-1/4 mr-0 md:mr-10 md:self-center">
              <StaticImage
                layout="fullWidth"
                alt="DJ N47"
                src={'Footer/DJ-N47.jpg'}
                formats={['auto', 'webp', 'avif']}
                className="rounded-full max-w-xs m-auto my-10  md:m-0"
              />
            </div>
            <div className="basis-full md:basis-3/4 md:mr-10 text-center md:text-justify">
              <p className="mt-0">
                Alex, alias N47 est un artiste aux racines corses et originaire
                du sud de la France. Il s'est lancé dans la musique dans les
                années 2000 en créant des beats pour son groupe de rap de
                l'époque. Attiré par l'univers underground du hip-hop, il s'est
                diversifié en explorant le rap, le graffiti, puis le
                turntablism. Sa musique mélange principalement instrumentales
                hip-hop, beatmaking et scratch. Ses morceaux cherchent à
                immerger les auditeurs dans différents univers.
              </p>
              <Link to={`/a-propos-de-dj-n47`} className="text-red-600">
                Lire la suite
              </Link>
            </div>
          </div>
        </div>
        <div className="text-center basis-full order-3 mt-10 ">
          <Social />
          <Streaming />
        </div>
        <div className="basis-1/4 border-t border-zinc-700 lg:border-t-0 mt-10 lg:mt-0 pt-10 lg:pt-0 text-center lg:text-left order-2 mb-20 lg:mb-0">
          <h3 className="font-bold text-xl mb-2 text-white uppercase">Légal</h3>
          <ul>
            <li className="my-5">
              <Link className="underline text-gray-400" to="/mentions-legales">
                Mentions légales
              </Link>
            </li>
            <li className="my-5">
              <Link
                className="underline text-gray-400"
                to="/politique-de-confidentialite"
              >
                Protection des données
              </Link>
            </li>
            <li className="my-5">
              <Link
                className="underline text-gray-400"
                to="/politique-de-cookies"
              >
                Politique de cookies
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="container mx-auto mt-2 pt-5 border-t border-zinc-700 text-gray-400 text-center uppercase">
        www.djn47.com - tous droits réservés
      </div>
    </footer>
  )
}

export default Footer
